import { Link, useLoaderData } from 'react-router-dom'

import { RecordFactory } from '../../models/RecordFactory'
import { dateFormat } from '../../utils/dates'
import { currencyFormat } from '../../utils/numbers'
import { AppHeader } from '../app/AppHeader'

export const loader = async () => {
    await RecordFactory.getInstance().fetchBalances()
    const balances = await RecordFactory.getInstance().loadBalances()
    return { balances }
}

export const DashboardDetailDepositsPage = () => {
    const data = useLoaderData() as Awaited<ReturnType<typeof loader>>

    return (
        <AppHeader title="Deposits" showBackButton={true} middleWidget={null}>
            <div className="dashboardDetails">
                <>
                    <div className="header">
                        <h2>Balance history</h2>
                    </div>
                    <div className="separator" />
                    <div className="list">
                        {data.balances.length === 0 && (
                            <div className="empty">
                                <p>Nothing here yet.</p>
                                <p style={{ fontWeight: 700, padding: '8px 0' }}>You got this!</p>
                            </div>
                        )}
                        {data.balances.map(
                            ({ id, typeString, eventDate, amount, deposit, payment }) => (
                                <div className="card" key={`balance-${id}`}>
                                    <div className="titleArea">
                                        <div className="title">{typeString}</div>
                                        <div className="subtitle">
                                            {dateFormat(eventDate, 'MMMM D, YYYY')}
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div
                                            className="text"
                                            style={(amount ?? 0) < 0 ? { color: '#E22216' } : {}}
                                        >
                                            {currencyFormat(amount)}
                                        </div>
                                        {!!deposit && (
                                            <Link to={`/deposits/${deposit.id}`}>View</Link>
                                        )}
                                        {!!payment && (
                                            <Link to={`/payments/${payment.id}`}>View</Link>
                                        )}
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </>
            </div>
        </AppHeader>
    )
}
